<template>
  <div class="file-box-loading">
    <div class="file-box-loading__icon">
      <svg-loader src="/static/images/icon-attachment-clip.svg" />
    </div>
    <div class="file-box-loading__loading-message">
      <p>{{ loadingMessage }}</p>
    </div>
    <div class="file-box-loading__spinner">
      <spinner class="medium" />
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'

export default {
  name: 'FileBoxSuccess',
  components: {
    'spinner': Spinner
  },
  props: {
    loadingMessage: {
      type: String,
      default: 'Carregando...'
    }
  }
}
</script>

<style lang="scss">
.file-box-loading {
  display: flex;
  background-color: #ebebeb;
  border-radius: 4px;
  height: 52px;
  align-items: center;
  padding: 0 1em 0 0.6em;

  &__icon,
  &__spinner {
    flex: 1;
    align-content: center;
    display: flex;
  }

  &__icon {
    svg {
      opacity: 0.7;
      height: 16px;
      width: 16px;
    }
  }

  &__loading-message {
    flex: 6;

    p {
      opacity: 0.7;
      margin: 0;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 12px;
      letter-spacing: 1.33px;
      color: #7a7a7a;
    }
  }

  &__spinner {
    .loader.medium {
      width: 25px;
      height: 25px;
    }
  }
}
</style>

